<template>
  <div class="card" v-if="nuevoProducto">
    <!-- <CrudProveedor></CrudProveedor> -->
  </div>
  <ProductoCreate
    :mostrar="mostrarProductoModal"
    :producto="producto"
    @closeModal="cerrarModal"
    @actualizarListadoProductos="obtenerListadoProductos"
  ></ProductoCreate>
  <ul class="clase-breadcrumb">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Par&aacute;metros</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Productos</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <router-link to="/productos" class="text-900 line-height-3"
        >Listado de Productos</router-link
      >
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Productos - Servicios
          <Badge size="xlarge" severity="success"> {{ totalRecords }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          label="Nuevo"
          v-if="'Producto Crear' in auth.user.permissions"
          class="p-button-info mr-2 p-button-lg"
          icon="pi pi-plus"
          v-tooltip.top="'Registrar Nuevo Producto'"
          @click="openModal"
          :disabled="!cargando ? false : true"
        ></Button>
      </div>
    </div>
    <div class="col-12 estilos-form mt-2">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-2">
          <span><strong>C&Oacute;DIGO:</strong></span>
          <InputNumber
            :class="'text-right'"
            v-model="codigo_interno"
            mode="decimal"
            :minFractionDigits="0"
            :maxFractionDigits="0"
            :min="0"
            :max="999999"
            @keyup.enter="obtenerListadoProductos()"
          />
        </div>
        <div class="field col-12 md:col-5">
          <span><strong>NOMBRE/DESCRIPCI&Oacute;N:</strong></span>
          <InputText
            v-model="descripcion"
            @keyup.enter="obtenerListadoProductos()"
          />
        </div>
        <div class="field col-12 md:col-2">
          <span><strong>PRODUCTO/SERVICIO:</strong></span>
          <Dropdown
            v-model="tipo_catalogo"
            :options="tiposCatalogo"
            optionLabel="label"
            optionValue="value"
            @change="obtenerListadoProductos"
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-1">
          <span><strong>REGISTROS:</strong></span>
          <Dropdown
            v-model="cantidadSeleccionada"
            :options="cantidades"
            optionLabel="label"
            optionValue="value"
            @change="obtenerListadoProductos"
          />
        </div>
        <div class="field col-12 md:col-2">
          <span>&nbsp;</span>
          <Button
            label="BUSCAR"
            icon="pi pi-search"
            class="p-button-info"
            @click="obtenerListadoProductos()"
          />
        </div>
      </div>
    </div>
    <div class="mt-2">
      <DataTable
        ref="dtproductos"
        :value="productos"
        dataKey="id"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[20, 50, 100, 200]"
        currentPageReportTemplate="Mostrando {first} de {totalRecords} Productos"
        responsiveLayout="scroll"
        stripedRows
        showGridlines
        :loading="cargando"
        :paginator="true"
        :rows="20"
        :rowHover="true"
        :totalRecords="totalRecords"
        selectionMode="single click"
        @row-dblclick="editarProducto($event.data)"
      >
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >
        <!--  <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column> -->

        <Column field="id" header="CÓD." :class="'text-right'"> </Column>
        <Column
          field="descripcion"
          header="DESCRIPCIÓN/DETALLE"
          style="width: 300px; font-weight: bold"
        >
          {{ data.descripcion }}
        </Column>

        <Column field="fabricas.nombre" header="GRUPO">
          {{ data.fabricas.nombre }}
        </Column>
        <Column field="unidad_medida_nombre" header="U.MEDIDA">
          {{ data.unidad_medida_nombre }}
        </Column>
        <Column class="text-center" field="stock_actual" header="S.ACTUAL">
          <template #body="{ data }">
            <div v-if="data.tipo_catalogo == 1" :class="claseEstado2(data)">
              {{ sinDecimal(data.stock_actual) }}
            </div>
            <div v-else>SERVICIO</div>
          </template>
        </Column>
        <Column field="precio_sugerido" header="P.VENTA" class="text-right">
          <template #body="{ data }">
            <span v-if="data.precio_venta == 0">
              {{ convertirNumeroGermanicFormat(data.precio_sugerido) }}
            </span>
            <span v-else>
              {{ convertirNumeroGermanicFormat(data.precio_venta) }}
            </span>
          </template>
        </Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <Badge v-if="data.estado == 1" size="small" severity="success"
              >ACTIVO</Badge
            >
            <Badge v-else size="small" severity="danger">INACTIVO</Badge>
          </template>
        </Column>
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised p-button-rounded p-button-info"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>
    <Dialog
      v-model:visible="deleteProdModal"
      :style="{ width: '450px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="producto"
          >Estas Seguro que quieres eliminar producto:
          <b>{{ producto.descripcion }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="No, Cancelar"
          icon="pi pi-times"
          class="p-button-success p-button-lg"
          @click="deleteProdModal = false"
        />
        <Button
          label="Si Eliminar"
          icon="pi pi-check"
          class="p-button-danger p-button-lg"
          @click="deleteProducto"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import ProductService from "@/service/ProductService";
import ProductoCreate from "@/module/productos/ProductoCreate.vue";
import { useAuth } from "@/stores";

export default {
  components: { ProductoCreate },
  data() {
    return {
      nuevoProducto: false,
      totalRecords: 0,
      productos: [],
      cargando: true,
      mostrarProductoModal: false,
      producto: {},
      deleteProdModal: false,
      claseEstado: ["status-outofstock", "status-instock"],
      claseEstado2: (data) => {
        if (data.stock_actual <= 0) {
          return "outofstock";
        } else if (data.stock_actual <= 10) {
          return "lowstock";
        } else {
          return "instock";
        }
      },
      ultimo_codigo_interno: null,
      codigo_interno: null,
      descripcion: "",
      cantidadSeleccionada: 50,
      cantidades: [
        { label: "50", value: 50 },
        { label: "100", value: 100 },
        { label: "200", value: 200 },
        { label: "500", value: 500 },
        { label: "1000", value: 1000 },
      ],
      tipo_catalogo: 0,
      tiposCatalogo: [
        { label: "TODOS", value: 0 },
        { label: "Producto", value: 1 },
        { label: "Servicio", value: 2 },
      ],
    };
  },
  productoService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.productoService = new ProductService();
  },
  mounted() {
    this.obtenerListadoProductos();
  },
  methods: {
    sinDecimal(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
      }).format(numero);
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "Producto Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editarProducto(datos);
          },
        },
        {
          label: "Ver Detalle",
          disabled:
            "Producto Ver Detalle" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-eye",
          command: () => {
            this.verDetalle(datos);
          },
        },
        {
          label: "Eliminar",
          disabled: "Producto Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.confirmDeleteProducto(datos);
          },
        },
      ];
    },
    openModal() {
      this.producto = {
        estado: { label: "Activo", value: 1 },
        stock_minimo: 0,
        stock_maximo: 0,
        precio_sugerido: null,
        precio_compra: null,
        comision_medico: null,
        comision_vendedor: null,
        comision_solicitante: null,
        tipo_catalogo: 2,
        codigo_interno: this.ultimo_codigo_interno ?? "",
        actualizar_precio_compra: 1,
      };
      this.mostrarProductoModal = true;
    },
    cerrarModal() {
      this.mostrarProductoModal = false;
      this.producto = {};
    },
    obtenerListadoProductos() {
      let datos = {
        codigo_interno: this.codigo_interno,
        descripcion: this.descripcion,
        cantidad: this.cantidadSeleccionada,
        tipo_catalogo: this.tipo_catalogo,
      };
      this.cargando = true;
      this.productoService.getAllProductosListado(datos).then((data) => {
        this.totalRecords = data.totalRecords ?? 0;
        this.productos = data.productos ?? [];
        this.cargando = false;
        if (this.productos.length > 0) {
          this.ultimo_codigo_interno =
            data.productos[0].codigo_interno &&
            !isNaN(data.productos[0].codigo_interno)
              ? parseInt(data.productos[0].codigo_interno) + 1
              : data.productos[0].codigo_interno ?? "";
        }
      });
    },
    textoEstado(estado) {
      return estado == 1 ? "Activo" : "Inactivo";
    },
    editarProducto(info_producto) {
      this.producto = { ...info_producto };
      this.producto.estado = {
        label: this.textoEstado(info_producto.estado),
        value: info_producto.estado,
      };
      this.producto.stock_minimo = parseInt(this.producto.stock_minimo || 0);
      this.producto.stock_maximo = parseInt(this.producto.stock_maximo || 0);
      this.producto.precio_sugerido =
        this.producto.precio_sugerido > 0
          ? parseFloat(this.producto.precio_sugerido)
          : null;
      this.producto.precio_compra =
        this.producto.precio_compra > 0
          ? parseInt(this.producto.precio_compra)
          : null;
      this.producto.stock_actual =
        this.producto.stock_actual > 0
          ? parseInt(this.producto.stock_actual)
          : null;
      this.producto.tipo_catalogo = parseInt(this.producto.tipo_catalogo || 1);
      this.producto.comision_medico =
        this.producto.stock.length > 0
          ? parseFloat(this.producto.stock[0].comision_medico)
          : null;
      this.producto.comision_vendedor =
        this.producto.stock.length > 0
          ? parseFloat(this.producto.stock[0].comision_vendedor)
          : null;
      this.producto.comision_solicitante =
        this.producto.stock.length > 0
          ? parseFloat(this.producto.stock[0].comision_solicitante)
          : null;

      this.mostrarProductoModal = true;
    },
    verDetalle(producto) {
      this.$router.push(`/producto/${producto.id}/detalle`);
    },
    confirmDeleteProducto(producto) {
      this.producto = { ...producto };
      this.deleteProdModal = true;
    },
    deleteProducto() {
      this.productoService.deleteProducto(this.producto).then((response) => {
        if (response.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Exito",
            detail: response.mensaje,
            life: 3000,
          });
          this.productos = this.productos.filter(
            (val) => val.id !== this.producto.id
          );
          this.deleteProdModal = false;
          this.producto = {};
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.mensaje,
            life: 3000,
          });
          this.deleteProdModal = false;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}

.outofstock {
  font-weight: 700;
  color: #000000;
  background-color: #ff5252;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}
.estilos-form {
  background-color: #ececec;
  border: 1px solid #000;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 10px;
}
.clase-breadcrumb {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 500;
}
</style>
